import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../../assets/css/digital.css";
import data from "../ApiUrl/meta_api.js";
import { toast } from "react-toastify";
import pdfFile1 from "../../assets/pdf/Digital Marketing/SkimitarAcademy - Advanced Digital Marketing Strategies -3M.pdf";
import pdfFile2 from "../../assets/pdf/Digital Marketing/SkimitarAcademy - Digital Marketing Mastery -6M.pdf";
import pdfFile from "../../assets/pdf/Digital Marketing/SkimitarAcademy - Digital Marketing Power-Up -1M.pdf";

const PRIMARY = "#cc0000";

const year = new Date().getFullYear();

/* ── Reusable section label (same as Contact page) ── */
function SectionLabel({ text }) {
  return (
    <p
      className="fw-semibold text-uppercase mb-1"
      style={{ fontSize: 20, color: "#cc0000", letterSpacing: 1 }}
    >
      {text}
    </p>
  );
}

const datas = [
  { data: "Industry Expert Trainers" },
  { data: "Live Campaign Execution" },
  { data: "AI-First 2026 Curriculum" },
  { data: "15+ Global Certifications" },
  { data: "100% Placement Assistance" },
];

const courses = [
  {
    title: "Digital Marketing Power-Up",
    duration: "1 Month",
    img: require("../../assets/images/Services/Digital Marketing/map-lying-wooden-table.webp"),
    desc: "Digital Marketing Power-Up is designed to supercharge your marketing skills and provide a comprehensive understanding of the most impactful digital marketing tools and strategies.",
    key: "Digital Marketing Power-Up",
  },
  {
    title: "Advanced Digital Marketing Strategies",
    duration: "3 Months",
    img: require("../../assets/images/Services/Digital Marketing/digital-marketing-with-icons-business-people.webp"),
    desc: "Advanced Digital Marketing Strategies takes your marketing knowledge to the next level by diving deep into cutting-edge techniques and trends that drive success in the digital world.",
    key: "Advanced Digital Marketing Strategies",
  },
  {
    title: "Digital Marketing Mastery",
    duration: "6 Months",
    img: require("../../assets/images/Services/Digital Marketing/corporate-management-strategy-solution-branding-concept.webp"),
    desc: "Digital Marketing Mastery is a comprehensive program designed to equip you with the skills and knowledge needed to succeed in today's fast-paced digital landscape.",
    key: "Digital Marketing Mastery",
  },
];

const curriculum = [
  {
    icon: "fa-brands fa-searchengin",
    title: "Search Engine Optimization (SEO)",
    desc: "Master the art of optimizing content for search engines to increase visibility and organic traffic.",
  },
  {
    icon: "fa-brands fa-blogger-b",
    title: "Content Marketing",
    desc: "Develop skills to create compelling content that attracts and converts your target audience.",
  },
  {
    icon: "fa-solid fa-bullhorn",
    title: "Social Media Marketing",
    desc: "Build a strong brand presence and drive sales on platforms like Facebook, Instagram, LinkedIn, and X (Twitter).",
  },
  {
    icon: "fa-solid fa-file-signature",
    title: "Pay-Per-Click (PPC) Advertising",
    desc: "Learn how to create, manage, and optimize PPC campaigns for maximum ROI.",
  },
  {
    icon: "fa-regular fa-envelope",
    title: "Email Marketing",
    desc: "Understand how to build and nurture relationships through effective email campaigns.",
  },
  {
    icon: "fa-solid fa-chart-line",
    title: "Analytics & Reporting",
    desc: "Measure, analyze, and report on your digital marketing efforts using tools like Google Analytics.",
  },
];

const learningOptions = [
  {
    num: "01",
    title: "In-Person Classes",
    desc: "Join our hands-on classroom sessions at our Erode training centre for an immersive learning experience.",
  },
  {
    num: "02",
    title: "Online Courses",
    desc: "Access training materials from anywhere, at any time, with our flexible self-paced online courses.",
  },
  {
    num: "03",
    title: "Live Webinars",
    desc: "Participate in live, instructor-led webinars that allow you to ask questions and get real-time feedback.",
  },
  {
    num: "04",
    title: "Aspiring Digital Marketers",
    desc: "Beginners who want to kick-start a rewarding career in digital marketing.",
  },
  {
    num: "05",
    title: "Marketing Professionals",
    desc: "Individuals looking to upskill and stay current with the latest digital marketing trends.",
  },
  {
    num: "06",
    title: "Entrepreneurs & Business Owners",
    desc: "Business owners who want to effectively market their products or services online.",
  },
];

const outcomes = [
  "A solid understanding of digital marketing fundamentals and advanced techniques.",
  "Practical experience with digital marketing tools and platforms.",
  "The ability to create and execute successful digital marketing campaigns.",
  "Insights into the latest trends and best practices in digital marketing.",
  "A professional network of peers and industry experts.",
  "A recognized certification to boost your career.",
  "Skills to facilitate a seamless transition into a digital marketing career.",
];

function DigitalMarketing() {
  const [meta, setMeta] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCourseData, setIsCourseData] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [downloadData, setDownloadData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPageDisabled, setIsPageDisabled] = useState(false);
  const [showOtherLocationField, setShowOtherLocationField] = useState(false);
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState({
    student_name: "",
    email: "",
    mobile_no: "",
    location: "",
    Prefered_course: "",
    source: "Website",
    enquiry_date: new Date().toISOString().split("T")[0],
  });

  useEffect(() => {
    const serviceMeta = data[0]?.digitalmarketing_page;
    if (serviceMeta) setMeta(serviceMeta);
    AOS.init({ duration: 800, once: true });
  }, []);

  const openModal = (courseKey) => {
    setIsCourseData(courseKey);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsCourseData("");
    setIsModalOpen(false);
  };

  const formatTime = () =>
    new Date().toLocaleTimeString("en-GB", { hour12: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
    if (name === "location") setShowOtherLocationField(value === "Others");
  };

  const handleSendMessage = async () => {
    const newErrors = {};
    if (!formValues.student_name.trim())
      newErrors.student_name = "Name is required.";
    else if (!/^[a-zA-Z\s]+$/.test(formValues.student_name))
      newErrors.student_name = "Name must contain only letters.";
    if (!formValues.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email))
      newErrors.email = "Enter a valid email address.";
    if (!formValues.mobile_no.trim())
      newErrors.mobile_no = "Mobile number is required.";
    else if (!/^\d{10}$/.test(formValues.mobile_no))
      newErrors.mobile_no = "Mobile number must be 10 digits.";
    if (!formValues.location.trim())
      newErrors.location = "Location is required.";
    else if (!/^[a-zA-Z\s]+$/.test(formValues.location))
      newErrors.location = "Location must contain only letters.";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    setIsLoading(true);
    setIsPageDisabled(true);
    try {
      const response = await axios.post(
        {},
        {
          ...formValues,
          fetched_course: isCourseData,
          Enquiry_time: formatTime(),
        },
        { headers: { "Content-Type": "application/json" } },
      );
      setFormValues({
        student_name: "",
        email: "",
        mobile_no: "",
        location: "",
        Prefered_course: "",
        source: "Website",
        enquiry_date: new Date().toISOString().split("T")[0],
      });
      if (response.status === 200) {
        const fileLinks = {
          "Digital Marketing Power-Up": pdfFile,
          "Advanced Digital Marketing Strategies": pdfFile1,
          "Digital Marketing Mastery": pdfFile2,
        };
        const selectedFile = fileLinks[isCourseData];
        if (selectedFile) {
          setDownloadData({
            fileUrl: selectedFile,
            fileName: isCourseData.replace(/\s+/g, "_").toLowerCase(),
          });
          setIsModalOpen(false);
          setIsPopupOpen(true);
        }
        toast.success("Data Sent Successfully!", { position: "top-center" });
        setTimeout(() => {
          setIsLoading(false);
          setIsPageDisabled(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("An error occurred while submitting the data. Please try again.");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsPageDisabled(false);
      }, 2000);
    }
  };

  const handleDownload = () => {
    if (downloadData) {
      const link = document.createElement("a");
      link.href = downloadData.fileUrl;
      link.download = downloadData.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsPopupOpen(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {meta
            ? meta.title
            : "Digital Marketing Training | Skimitar Hindusthan Pvt Ltd"}
        </title>
        {/* <link
          rel="canonical"
          href="https://skimitaracademy.com/digitalmarketing"
        /> */}
      </Helmet>

      {isLoading && (
        <div className="preloader">
          <img
            className="responsive-img"
            alt=""
            src={require("../../assets/images/SH Logo.webp")}
          />
        </div>
      )}

      <div className={`page-container ${isPageDisabled ? "blurred" : ""}`}>
        {/* ── Hero Banner ── */}
        <div
          className="backgroundCommenImage position-relative d-flex align-items-center mb-5"
          style={{
            backgroundImage: `url(${require("../../assets/images/Bannar/dm-banner.webp")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "60vh",
          }}
        >
          {/* Overlay */}
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{ background: "rgba(0, 0, 0, 0.8)", zIndex: 1 }}
          ></div>

          {/* Content */}
          <div
            className="container position-relative text-center text-white py-4 py-md-5"
            style={{ zIndex: 2 }}
          >
            {/* Badge */}
            <span
              className="fw-semibold d-inline-block mb-3 px-3 py-1 rounded-pill"
              style={{
                background: "#cc0000",
                fontSize: "clamp(10px,3vw,12px)",
                letterSpacing: "0.5px",
              }}
            >
              ✦ AI-Powered · Results-Driven · {year} Certified
            </span>

            {/* Heading */}
            <h1
              className="fw-semibold mb-3"
              style={{
                fontSize: "clamp(18px,5vw,28px)",
                lineHeight: 1.4,
              }}
            >
              Digital Marketing
              <br />
              <span style={{ color: PRIMARY }}>
                SEO · Ads · AI · Social · Automation
              </span>
            </h1>

            {/* Text */}
            <p
              className="mx-auto mb-4 px-2 px-md-0"
              style={{
                fontSize: "clamp(13px,3.5vw,15px)",
                maxWidth: "650px",
                lineHeight: 1.7,
                color: "#ebe6e6",
              }}
            >
              From your first Google Ad to running full-funnel AI-powered
              campaigns — Skimitar Hindusthan delivers India's most
              results-driven digital marketing training with real campaigns and
              real data.
            </p>

            {/* Pills */}
            <div className="d-flex flex-wrap justify-content-center gap-2 gap-md-3">
              {datas.map((s, i) => (
                <div
                  key={s.label}
                  className="text-white px-3 py-2 rounded-pill"
                  style={{
                    border: "1px solid rgba(255,255,255,0.3)",
                    fontSize: "clamp(8px,3vw,10px)",
                  }}
                >
                  <span className="fw-semibold">{s.data}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Intro ── */}
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center" data-aos="fade-up">
              <SectionLabel text="Digital Marketing" />
              <h1
                className="fw-semibold mb-3"
                style={{ fontSize: "clamp(22px,4vw,30px)" }}
              >
                Digital Marketing Training Program at Skimitar Hindusthan Pvt
                Ltd
              </h1>
              <p
                className="mx-auto"
                style={{
                  fontSize: "15px",
                  lineHeight: "1.85",
                  maxWidth: "820px",
                }}
              >
                Our Digital Marketing Course at Skimitar Hindusthan Pvt Ltd
                offers a comprehensive, hands-on approach to mastering key
                marketing strategies for the digital age. Covering SEO, SEM,
                social media marketing, email marketing, content creation, and
                analytics, this program provides essential skills to boost
                online visibility and drive business growth. Ideal for business
                owners, marketers, and anyone eager to thrive in the digital
                world.
              </p>
            </div>
          </div>
        </div>

        {/* ── Why Choose Us ── */}
        <div className="container py-5">
          <div className="row align-items-center g-5">
            <div className="col-lg-6" data-aos="fade-right">
              <SectionLabel text="Why Choose Us" />
              <h2 className="fw-semibold mb-3" style={{ fontSize: 15 }}>
                Why Choose Our Digital Marketing Training Program
              </h2>
              <p className="" style={{ fontSize: "15px", lineHeight: "1.85" }}>
                Skimitar Hindusthan Pvt Ltd's Digital Marketing Training Program
                offers a comprehensive, hands-on approach to mastering the
                skills necessary for success in the digital world. This program
                covers key areas such as SEO, SEM, social media marketing,
                content creation, email marketing, and analytics, providing a
                well-rounded education.
              </p>
              <p className="" style={{ fontSize: "15px", lineHeight: "1.85" }}>
                Through practical exercises and real-world case studies,
                participants gain the knowledge to design and execute effective
                digital marketing strategies. Our experienced instructors ensure
                training is up-to-date with the latest trends and tools,
                preparing you to meet the demands of a fast-paced industry.
              </p>
              <div className="d-flex flex-wrap gap-2 mt-3">
                {[
                  "Industry Experts",
                  "Real-World Projects",
                  "Job Assistance",
                  "Pan-India Batches",
                ].map((tag) => (
                  <span
                    key={tag}
                    className="badge rounded-pill border"
                    style={{
                      color: "#cc0000",
                      borderColor: "#cc0000",
                      fontSize: "12px",
                      padding: "7px 14px",
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="col-lg-6 text-center" data-aos="fade-up">
              <img
                src={require("../../assets/images/Services/Digital Marketing/overworked-workaholic.webp")}
                alt="Digital Marketing Training at Skimitar Hindusthan Pvt Ltd"
                className="img-fluid rounded"
                style={{
                  maxHeight: "420px",
                  objectFit: "cover",
                  width: "100%",
                }}
              />
            </div>
          </div>
        </div>

        {/* ── Our Training Programs ── */}
        <div className="bg-light py-5">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <SectionLabel text="Our Programs" />
              <h2
                className="fw-semibold"
                style={{ fontSize: "clamp(18px,3vw,24px)" }}
              >
                Explore Our Digital Marketing Training Programs
              </h2>
              <p
                className="text-muted mx-auto mt-2"
                style={{ fontSize: "15px", maxWidth: "600px" }}
              >
                Choose from flexible program durations designed to cater to
                various levels of expertise and career goals.
              </p>
            </div>

            <div className="row g-4 justify-content-center">
              {courses.map((course, i) => (
                <div
                  key={i}
                  className="col-12 col-sm-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-delay={i * 100}
                >
                  <div
                    className="card h-100 border shadow-sm"
                    style={{ borderRadius: "12px", overflow: "hidden" }}
                  >
                    <img
                      src={course.img}
                      className="card-img-top"
                      alt={course.title}
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="card-body d-flex flex-column p-4">
                      <span
                        className="badge mb-2 align-self-start"
                        style={{
                          background: "#fff0f0",
                          color: "#cc0000",
                          fontSize: "11px",
                          border: "1px solid #f5c6cb",
                        }}
                      >
                        Digital Marketing
                      </span>
                      <h5
                        className="fw-bold mb-2"
                        style={{ fontSize: "16px", color: "#cc0000" }}
                      >
                        {course.title}
                      </h5>
                      <p
                        className="text-muted flex-grow-1"
                        style={{ fontSize: "13px", lineHeight: "1.7" }}
                      >
                        {course.desc}
                      </p>
                      <div className="d-flex align-items-center justify-content-between mt-3 pt-2 border-top">
                        <span
                          className="text-muted"
                          style={{ fontSize: "12px" }}
                        >
                          <i
                            className="fa-solid fa-clock me-1"
                            style={{ color: "#cc0000" }}
                          ></i>
                          {course.duration}
                        </span>
                        <button
                          className="btn btn-sm text-white"
                          style={{
                            background: "#cc0000",
                            fontSize: "12px",
                            borderRadius: "6px",
                            padding: "6px 16px",
                          }}
                          onClick={() => openModal(course.key)}
                        >
                          View Course
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Comprehensive Curriculum ── */}
        <div className="container py-5">
          <div className="text-center mb-5" data-aos="fade-up">
            <SectionLabel text="Curriculum" />
            <h2
              className="fw-semibold"
              style={{ fontSize: "clamp(18px,3vw,24px)" }}
            >
              Comprehensive Digital Marketing Curriculum
            </h2>
            <p
              className="text-muted mx-auto mt-2"
              style={{ fontSize: "15px", maxWidth: "580px" }}
            >
              A structured curriculum built to take you from foundational
              knowledge to advanced marketing mastery.
            </p>
          </div>

          <div className="row align-items-center g-4">
            {/* Left 3 */}
            <div className="col-lg-4 col-md-12" data-aos="fade-right">
              {curriculum.slice(0, 3).map((item, i) => (
                <div key={i} className="d-flex align-items-start mb-4">
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0 me-3"
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "10px",
                      background: "#fff0f0",
                      color: "#cc0000",
                    }}
                  >
                    <i className={`${item.icon} fa-lg`}></i>
                  </div>
                  <div>
                    <h5
                      className="fw-semibold mb-1"
                      style={{ fontSize: "15px" }}
                    >
                      {item.title}
                    </h5>
                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: "13px", lineHeight: "1.6" }}
                    >
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Center image */}
            <div
              className="col-lg-4 text-center d-none d-lg-block"
              data-aos="zoom-in"
            >
              <img
                src={require("../../assets/images/Services/Digital Marketing/busy-woman-working.webp")}
                className="img-fluid rounded shadow"
                alt="Digital Marketing Curriculum — Skimitar Hindusthan Pvt Ltd"
                style={{
                  maxHeight: "400px",
                  objectFit: "cover",
                  width: "100%",
                  borderRadius: "14px",
                }}
              />
            </div>

            {/* Right 3 */}
            <div className="col-lg-4 col-md-12" data-aos="fade-up">
              {curriculum.slice(3).map((item, i) => (
                <div key={i} className="d-flex align-items-start mb-4">
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0 me-3"
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "10px",
                      background: "#fff0f0",
                      color: "#cc0000",
                    }}
                  >
                    <i className={`${item.icon} fa-lg`}></i>
                  </div>
                  <div>
                    <h5
                      className="fw-semibold mb-1"
                      style={{ fontSize: "15px" }}
                    >
                      {item.title}
                    </h5>
                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: "13px", lineHeight: "1.6" }}
                    >
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Certification ── */}
        <div className="bg-light py-5">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6" data-aos="fade-right">
                <SectionLabel text="Certification" />
                <h2
                  className="fw-semibold mb-3"
                  style={{ fontSize: "clamp(18px,3vw,24px)" }}
                >
                  Industry-Recognised Digital Marketing Certification
                </h2>
                <p
                  className="text-muted"
                  style={{ fontSize: "15px", lineHeight: "1.85" }}
                >
                  Upon completion of the course at Skimitar Hindusthan Pvt Ltd,
                  you'll receive a certification recognised by employers
                  worldwide. This certification demonstrates your proficiency in
                  digital marketing and can help you stand out in the job market
                  or advance in your current role.
                </p>
                <div className="d-flex flex-column gap-3 mt-4">
                  {[
                    "Completing our course earns you a certification respected and recognised by employers worldwide.",
                    "Our certification is aligned with industry standards, demonstrating your commitment to continuous learning and professional growth.",
                  ].map((text, i) => (
                    <div key={i} className="d-flex align-items-start gap-3">
                      <div
                        className="flex-shrink-0 d-flex align-items-center justify-content-center"
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          background: "#fff0f0",
                          color: "#cc0000",
                          marginTop: "2px",
                        }}
                      >
                        <i
                          className="fa-solid fa-check"
                          style={{ fontSize: "11px" }}
                        ></i>
                      </div>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "14px", lineHeight: "1.75" }}
                      >
                        {text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-6 text-center" data-aos="fade-up">
                <img
                  src={require("../../assets/images/Services/Digital Marketing/Certification Red.webp")}
                  alt="Digital Marketing Certification — Skimitar Hindusthan Pvt Ltd"
                  className="img-fluid rounded"
                  style={{ maxHeight: "380px", objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── Flexible Learning Options ── */}
        <div className="container py-5">
          <div className="text-center mb-5" data-aos="fade-up">
            <SectionLabel text="Learning Options" />
            <h2
              className="fw-semibold"
              style={{ fontSize: "clamp(18px,3vw,24px)" }}
            >
              Flexible Learning Options for Every Learner
            </h2>
            <p
              className="text-muted mx-auto mt-2"
              style={{ fontSize: "15px", maxWidth: "560px" }}
            >
              We offer multiple learning formats to fit your schedule, location,
              and learning style.
            </p>
          </div>

          <div className="row g-4">
            {learningOptions.map((opt, i) => (
              <div
                key={i}
                className="col-12 col-sm-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay={i * 80}
              >
                <div
                  className="d-flex align-items-start gap-3 p-4 h-100 border rounded bg-white"
                  style={{ borderRadius: "12px !important" }}
                >
                  <div
                    className="flex-shrink-0 d-flex align-items-center justify-content-center fw-bold text-white"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "#cc0000",
                      fontSize: "14px",
                    }}
                  >
                    {opt.num}
                  </div>
                  <div>
                    <h6
                      className="fw-semibold mb-1"
                      style={{ fontSize: "15px" }}
                    >
                      {opt.title}
                    </h6>
                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: "13px", lineHeight: "1.65" }}
                    >
                      {opt.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── What You'll Gain ── */}
        <div className="bg-light py-5">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-5 text-center" data-aos="fade-right">
                <img
                  src={require("../../assets/images/Services/Digital Marketing/person-office-analyzing-checking-finance-graphs.webp")}
                  alt="What You'll Gain from Digital Marketing Training at Skimitar Hindusthan Pvt Ltd"
                  className="img-fluid rounded"
                  style={{
                    maxHeight: "400px",
                    objectFit: "cover",
                    width: "100%",
                    borderRadius: "14px",
                  }}
                />
              </div>
              <div className="col-lg-7" data-aos="fade-up">
                <SectionLabel text="Learning Outcomes" />
                <h2
                  className="fw-semibold mb-1"
                  style={{ fontSize: "clamp(18px,3vw,24px)" }}
                >
                  What You'll Gain from This Program
                </h2>
                <p className="text-muted mb-4" style={{ fontSize: "15px" }}>
                  By the end of the Skimitar Hindusthan Pvt Ltd Digital
                  Marketing Program, you'll have a curated skill set with
                  expertise in areas critical to your industry's future.
                </p>
                <div className="row g-2">
                  {outcomes.map((text, i) => (
                    <div
                      key={i}
                      className="col-12"
                      data-aos="fade-up"
                      data-aos-delay={i * 60}
                    >
                      <div className="d-flex align-items-start gap-3">
                        <i
                          className="fa-regular fa-circle-check mt-1 flex-shrink-0"
                          style={{ color: "#cc0000", fontSize: "15px" }}
                        ></i>
                        <p
                          className="mb-0 text-muted"
                          style={{ fontSize: "14px", lineHeight: "1.7" }}
                        >
                          {text}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Enroll CTA Strip ── */}
        <div
          className="py-5 text-white text-center"
          style={{ background: "#cc0000" }}
          data-aos="fade-up"
        >
          <div className="container">
            <h2
              className="fw-semibold mb-2"
              style={{ fontSize: "clamp(18px,3vw,24px)" }}
            >
              Ready to Advance Your Digital Marketing Career?
            </h2>
            <p
              className="mb-4 mx-auto"
              style={{ fontSize: "15px", opacity: 0.9, maxWidth: "560px" }}
            >
              Join Skimitar Hindusthan Pvt Ltd's Digital Marketing Training
              Program and gain the skills to succeed in today's competitive
              online landscape.
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-3">
              {courses.map((c, i) => (
                <button
                  key={i}
                  className="btn btn-light fw-medium"
                  style={{
                    fontSize: "13px",
                    color: "#cc0000",
                    borderRadius: "8px",
                    padding: "10px 24px",
                  }}
                  onClick={() => openModal(c.key)}
                >
                  {c.title}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* ── Modal: Course Enquiry ── */}
        {isModalOpen && (
          <div
            className="modal d-block"
            style={{ background: "rgba(0,0,0,0.55)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content border-0 shadow"
                style={{ borderRadius: "14px" }}
              >
                <div className="modal-header border-0 pb-0 px-4 pt-4">
                  <div>
                    <SectionLabel text="Course Enquiry" />
                    <h5
                      className="fw-semibold mb-0"
                      style={{ fontSize: "17px" }}
                    >
                      {isCourseData}
                    </h5>
                  </div>
                  <button
                    className="btn-close ms-auto"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body px-4 pb-4 pt-3">
                  <div className="mb-3">
                    <label
                      className="form-label fw-medium"
                      style={{ fontSize: "12px" }}
                    >
                      Full Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your full name"
                      name="student_name"
                      value={formValues.student_name}
                      onChange={handleChange}
                      style={{ fontSize: "13px" }}
                    />
                    {errors.student_name && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "11px" }}
                      >
                        {errors.student_name}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label
                      className="form-label fw-medium"
                      style={{ fontSize: "12px" }}
                    >
                      Email Address *
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="your@email.com"
                      name="email"
                      value={formValues.email}
                      onChange={handleChange}
                      style={{ fontSize: "13px" }}
                    />
                    {errors.email && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "11px" }}
                      >
                        {errors.email}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label
                      className="form-label fw-medium"
                      style={{ fontSize: "12px" }}
                    >
                      Mobile Number *
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="+91 XXXXX XXXXX"
                      name="mobile_no"
                      value={formValues.mobile_no}
                      onChange={handleChange}
                      style={{ fontSize: "13px" }}
                    />
                    {errors.mobile_no && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "11px" }}
                      >
                        {errors.mobile_no}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label
                      className="form-label fw-medium"
                      style={{ fontSize: "12px" }}
                    >
                      Location *
                    </label>
                    <select
                      className="form-select"
                      name="location"
                      value={formValues.location}
                      onChange={handleChange}
                      style={{ fontSize: "13px" }}
                    >
                      <option value="">Select Location</option>
                      <option value="Salem">Salem</option>
                      <option value="Erode">Erode</option>
                      <option value="Others">Others</option>
                    </select>
                    {errors.location && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "11px" }}
                      >
                        {errors.location}
                      </div>
                    )}
                  </div>
                  {showOtherLocationField && (
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your location"
                        name="other_location"
                        value={formValues.other_location || ""}
                        onChange={handleChange}
                        style={{ fontSize: "13px" }}
                      />
                    </div>
                  )}
                  <div className="mb-4">
                    <label
                      className="form-label fw-medium"
                      style={{ fontSize: "12px" }}
                    >
                      Preferred Course
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={isCourseData || ""}
                      disabled
                      style={{ fontSize: "13px", background: "#f8f9fa" }}
                    />
                  </div>
                  <button
                    className="btn w-100 text-white fw-medium"
                    style={{
                      background: "#cc0000",
                      fontSize: "14px",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                    onClick={handleSendMessage}
                  >
                    Submit Enquiry →
                  </button>
                  <p
                    className="text-center text-muted mt-2 mb-0"
                    style={{ fontSize: "10px" }}
                  >
                    We respect your privacy. Your information will never be
                    shared.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Modal: Download ── */}
        {isPopupOpen && (
          <div
            className="modal d-block"
            style={{ background: "rgba(0,0,0,0.55)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content border-0 shadow text-center"
                style={{ borderRadius: "14px" }}
              >
                <div className="modal-body px-4 py-5">
                  <div
                    className="d-inline-flex align-items-center justify-content-center mb-3"
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      background: "#fff0f0",
                    }}
                  >
                    <i
                      className="fa-solid fa-file-arrow-down fa-xl"
                      style={{ color: "#cc0000" }}
                    ></i>
                  </div>
                  <h5 className="fw-semibold mb-2">
                    Your Course Brochure is Ready
                  </h5>
                  <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
                    Click below to download the course details for{" "}
                    <strong>{isCourseData}</strong>.
                  </p>
                  <div className="d-flex gap-3 justify-content-center">
                    <button
                      className="btn text-white fw-medium"
                      style={{
                        background: "#cc0000",
                        borderRadius: "8px",
                        padding: "10px 28px",
                        fontSize: "14px",
                      }}
                      onClick={handleDownload}
                    >
                      Download Brochure
                    </button>
                    <button
                      className="btn btn-outline-secondary fw-medium"
                      style={{
                        borderRadius: "8px",
                        padding: "10px 20px",
                        fontSize: "14px",
                      }}
                      onClick={() => setIsPopupOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DigitalMarketing;
